<template>
    <BasePopup v-if="isVisible" @close="isVisible = false" :class="'download-info-content'">
        <DownloadInfoContent
            @close="isVisible = false"
            :contentID="id"
            :title="overwriteTitle || title"
            :hasUser="hasUser"
            :downloadLimitExceeded="downloadLimitExceeded"
            :downloadNotPossible="downloadNotPossible"
            :contentType="contentType"
            :status="status"
            :testLicenceCanceled="testLicenceCanceled"
            :userLicenceName="userLicenceName"
            :isInCart="isInCart"
            :singleOrdered="singleOrdered"
            :singleNotPaid="singleNotPaid"
            :isLicenseActive="isLicenseActive"
            :isLicenseTester="isLicenseTester"
            :buttons="buttons"
        />
    </BasePopup>
</template>

<script>
import BasePopup from "@/components/Frontend/BasePopup.vue"
import DownloadInfoContent from "@/components/Frontend/DownloadInfoContent.vue"

export default {
    name: "DownloadInfo",
    components: { BasePopup, DownloadInfoContent },
    props: [
        "id",
        "title",
        "user-licence-name",
        "is-in-cart",
        "single-ordered",
        "single-not-paid",
        "is-license-active",
        "is-license-tester",
        "buttons",
    ],
    data() {
        return {
            hasUser: false,
            isVisible: false,
            downloadLimitExceeded: 0,
            downloadNotPossible: false,
            overwriteTitle: false,
            contentType: false,
            status: undefined,
            testLicenceCanceled: false,
        }
    },
    created() {
        let self = this
        setTimeout(() => {
            if (!window.eventBus) {
                return
            }
            // default: asset
            window.eventBus.$on("download_not_allowed", (...props) => {
                this.hasUser = props[0]
                this.downloadNotPossible = true
                this.contentType = ""
                this.isVisible = true
                this.status = props[2]
                this.testLicenceCanceled = props[1]
            })

            window.eventBus.$on("ebook_download_not_allowed", (...props) => {
                this.hasUser = props[0]
                this.downloadNotPossible = true
                this.contentType = "ebook"
                this.isVisible = true
                this.status = props[2]
                this.testLicenceCanceled = props[1]
            })

            window.eventBus.$on("tutorial_not_possible", (...props) => {
                this.hasUser = props[0]
                this.downloadNotPossible = true
                this.contentType = "tutorial"
                this.isVisible = true
                this.status = props[2]
                this.testLicenceCanceled = props[1]
            })

            window.eventBus.$on("pdf_tutorial_not_possible", (...props) => {
                this.hasUser = props[0]
                this.downloadNotPossible = true
                this.contentType = "pdf"
                this.isVisible = true
                this.status = props[2]
                this.testLicenceCanceled = props[1]
            })

            window.eventBus.$on("streaming_not_possible", (...props) => {
                this.hasUser = props[0]
                this.downloadNotPossible = true
                this.contentType = "video"
                this.isVisible = true
                this.status = props[2]
                this.testLicenceCanceled = props[1]
            })

            window.eventBus.$on("working_file_download_not_allowed", (...props) => {
                this.hasUser = props[0]
                this.downloadNotPossible = true
                this.contentType = "working-file"
                this.isVisible = true
                this.status = props[2]
                this.testLicenceCanceled = props[1]
            })

            window.eventBus.$on("download_limit_exceeded", (...props) => {
                this.hasUser = props[0]
                this.downloadLimitExceeded = props[2]
                this.isVisible = true
                this.status = props[3]
                this.testLicenceCanceled = props[1]
            })
        }, 1)
    },
    methods: {
        close() {
            this.isVisible = false
        },
    },
}
</script>
